import * as React from "react"
import type { WidgetProps } from "@rjsf/utils"
import TextField from "@mui/material/TextField"
import Tooltip from "@mui/material/Tooltip"

const URL_REGEX = /^(https?:\/\/)([^\s.]+\.[^\s]{2,})(\/\S*)?$/i

export const UrlWidget: React.FC<WidgetProps> = (props) => {
  const { id, value, label, onChange, disabled, readonly, required } = props

  const [input, setInput] = React.useState<string>(String(value ?? ""))
  const [error, setError] = React.useState<string>("")

  const normalize = (v: string) => {
    const trimmed = v.trim()
    if (!trimmed) {
      setError("")
      return ""
    }
    if (!/^https?:\/\//i.test(trimmed)) return `https://${trimmed}`
    return trimmed
  }

  const validate = (v: string) => {
    if (!v) {
      setError("") // opcional
      return true
    }
    const ok = URL_REGEX.test(v)
    setError(ok ? "" : "Ingresa una URL válida (ej. https://empresa.com/path)")
    return ok
  }

  const handleBlur = () => {
    const next = normalize(input)
    setInput(next)
    if (validate(next)) onChange(next)
  }

  return (
    <Tooltip
      title="Usado para negocios externos: mostrará un enlace externo al seleccionar este featured como Business."
      placement="top-start"
    >
      <TextField
        id={id}
        label={label ?? "URL"}
        placeholder="https://empresa.com"
        fullWidth
        variant="outlined"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onBlur={handleBlur}
        inputProps={{
          inputMode: "url",
          pattern: input ? URL_REGEX.source : undefined, // ayuda al navegador
          autoCapitalize: "none",
          autoCorrect: "off",
          spellCheck: "false",
        }}
        error={!!error}
        helperText={error || "Ejemplo: https://empresa.com/ofertas (solo para negocios externos)"}
        required={required}
        disabled={disabled || readonly}
      />
    </Tooltip>
  )
}
